<template>
<div class="my-map">
	<div id="map" />
	<div id="preview-map">
		<div class="circle-preview"></div>
	</div>
</div>
</template>

<script>
import Vue from 'vue'
import mapboxgl from 'mapbox-gl'
import mapConfig from '@/config/mapConfig'
import Minimap from '@/utils/mapbox-minimap.js'
import syncMove from '@/utils/mapbox-sync-move.js'
import OilPopupComponent from './OilPopup'
import { getDistanceBetweenPoints } from '@/utils/mapbox-directions'
import { getDistanceBetweenTwoPoints, randomNumber } from '@/utils/helpers'
import { mapActions, mapState } from 'vuex'

const OilPopupClass = Vue.extend(OilPopupComponent)

export default {
	components: {
		OilPopupComponent
	},
	data: () => ({
		map: null,
		previewMap: null,
		markerList: [],
		pointList: [],
		markerAnimationInterval: null,
	}),
	computed: {
		...mapState({
			regions: ({ RegionStore }) => RegionStore.list
		})
	},
	created() {
		this.runMapEvents()
		this.getRegions()
	},
	mounted() {
		mapboxgl.accessToken = mapConfig.ACCESS_TOKEN

		this.map = new mapboxgl.Map({
			container: 'map',
			style: mapConfig.MAPBOX_STYLE,
			center: mapConfig.INITIAL_CENTER,
			zoom: mapConfig.DEFAULT_ZOOM,
			attributionControl: false,
			logoPosition: 'bottom-right'
		})
		this.previewMap = new mapboxgl.Map({
			container: 'preview-map',
			style: mapConfig.MAPBOX_STYLE,
			center: mapConfig.INITIAL_CENTER,
			zoom: mapConfig.PREVIEW_MAP_ZOOM,
			attributionControl: false,
			interactive: false
		})
		syncMove(this.map, this.previewMap)
		
		this.map.on('load', (data) => {
			let map = data.target
			map.addSource("states", {
				"type": "geojson",
				"data": require('../../../sources/regionOfPeru.json')
			})
			map.addLayer({
				"id": "state-fills",
				"type": "fill",
				"source": "states",
				"layout": {},
				"paint": {
					"fill-color": "#627BC1",
					"fill-opacity": [
						"case",
						[
							"boolean",
							[
								"feature-state",
								"hover"
							],
							false
						],
						0.5,
						0
					]
				}
			})
			this.highlightRegions()
		})
		this.map.addControl(new mapboxgl.NavigationControl())
	},
	methods: {
		...mapActions({
			getRegions: 'RegionStore/getList'
		}),
		activateMarker(id) {
			this.hideActiveMarkers()
			let element = document.getElementById('marker_opportunity_' + id)
			if(element) {
				element.className = 'marker active'
			}
		},
		hideActiveMarkers() {
			let allMarkers = document.querySelectorAll('.marker')
			allMarkers.forEach((marker) => {
				marker.classList.remove("active")
			})
		},
		highlightRegions() {
			let source = this.map.getSource('states')
			if(!source) return
			let query = this.$route.query
			let selectedRegions = []
			if(query.regionId) {
				if(typeof query.regionId == 'string') {
					selectedRegions = [parseInt(query.regionId)]
				} else {
					selectedRegions = query.regionId.map(Number)
				}
			}
			let regionsName = this.regions.filter(region => {
				return selectedRegions.find(id => id == region.id)
			}).map(region => region.name.toUpperCase())
			
			source._data.features.map(element => {
				this.map.setFeatureState({source: 'states', id: element.id}, { hover: false });
			})
			source._data.features.map(element => {
				regionsName.map(region => {
					if(region == element.properties.NOMBDEP) {
						this.map.setFeatureState({source: 'states', id: element.id}, { hover: true });
					}
				})
			})
		},
		createMarkers(points) {
			this.removeAllMarkers()
			this.map.flyTo({
				zoom: 6
			})
			points.map(element => {
				this.createMarker({
					opportunity: element,
					active: false
				})

			})
		},
		createMarker(data) {
			let coord = data.opportunity.center.slice()
			let element = document.createElement('div')
			element.className = 'marker'
			element.id = 'marker_opportunity_' + data.opportunity.id

			if(data.active) {
				element.className = 'marker active'
				this.map.flyTo(data.opportunity)
			}
			else {
				element.addEventListener("mouseover", () => {
					this.$root.$emit('activateOpportunity', data.opportunity.id)
				})
				element.addEventListener("mouseleave", () => {
					this.$root.$emit('deactivateOpportunities')
				})
			}
			let marker = null

			let popupElement = document.createElement('div')
				popupElement.id = 'vue-popup-content'

			let popup = new mapboxgl.Popup({
				anchor: 'bottom-left',
				closeButton: false,
				className: 'popup-oil'
			})
			.setDOMContent(popupElement)
			
			if(data.opportunity.sectorId == 29 || data.opportunity.sectorId == 30) {
				this.createIndicator(data.opportunity)
			}
			let indicator = document.getElementsByClassName('indicator_' + data.opportunity.id)[0]
			popup.on('open', () => {
				let currentMarker = document.getElementById('marker_opportunity_' + data.opportunity.id)
				currentMarker.classList.add('popupActive')
				if(indicator) indicator.style.display = 'block'
			})
			popup.on('close', () => {
				if(indicator) indicator.style.display = 'none'
				popup._content.children[0].classList.remove('active')
				let currentMarker = document.getElementById('marker_opportunity_' + data.opportunity.id)
				if(currentMarker) {
					currentMarker.classList.remove('popupActive')
				}
			})

			marker = new mapboxgl.Marker(element)
				.setLngLat(coord)
				.setPopup(popup)
				.addTo(this.map)

			let vm = this
			const popupInstance = new OilPopupClass({
				propsData: {
					vm,
					opportunity: data.opportunity
				},
				methods: {
					removeAllPopup() {
						vm.removeAllPopup()
					}
				}
			})
			popupInstance.$mount(popupElement)
			popup._update()
			
			this.markerList.push({
				id: data.opportunity.id,
				marker
			})
		},
		removeAllPopup() {
			this.markerList.map(item => {
				let popup = item.marker.getPopup()
				if(popup) {
					popup.remove()
				}
			})
		},
		removeAllMarkers() {
			this.removeAllPopup()
			this.markerList.map(item => {
				item.marker.remove()
			})
			this.markerList = []
		},
		createIndicator(opportunity) {
			let element = document.createElement('div')
			element.className = 'indicator indicator_' + opportunity.id
			new mapboxgl.Marker(element)
				.setLngLat(opportunity.shore_coord)
				.addTo(this.map)
		},
		removeAllIndicators() {
			let allIndicators = document.querySelectorAll('.indicator')
			allIndicators.forEach((indicator) => {
				indicator.remove()
			})
		},
		createPointOfInterest(data) {
			let coord = [
				data.place.lon,
				data.place.lat
			]
			let element = document.createElement('div')
			element.className = 'point-of-interest-marker point-type-' + data.type

			let distance = (getDistanceBetweenTwoPoints(coord, data.opportunity.center)).toFixed(2)

			let popupHtml = `
				<h4>` + data.place.tags.name + `</h4>
				<span>` + distance + `km away</span>
				<ul>
			`
			if(data.place.tags.website) {
				popupHtml += `<li><a href="` + data.place.tags.website + `">visit website</a></li>`
			}
			if(data.place.tags.url) {
				popupHtml += `<li><a href="` + data.place.tags.url + `">visit website</a></li>`
			}
			let popup = new mapboxgl.Popup({
				anchor: 'top',
				className: 'point-popup',
				closeButton: false
			})
			.setHTML(popupHtml)

			popup.on('open', () => {
				let popupList = document.getElementsByClassName('point-popup')
				if(popupList.length > 0) {
					Array.from(popupList).map(element => {
						element.classList.add('active')
					})
				}
			})

			let point = new mapboxgl.Marker(element)
				.setLngLat(coord)
				.setPopup(popup)
				.addTo(this.map)
			
			this.pointList.push(point)
		},
		removeAllPointsOfInterest() {
			this.pointList.map(point => {
				let popup = point.getPopup()
				if(popup) {
					popup.remove()
				}
				point.remove()
			})
			this.pointList = []
		},
		runMarkerAnimation() {
			let index = randomNumber(0, (this.markerList.length - 1))
			this.markerAnimationInterval = setInterval(() => {
				this.markerList[index].marker._element.classList.remove('active')
				index = randomNumber(0, (this.markerList.length - 1))
				this.markerList[index].marker._element.classList.add('active')
			}, 1000)
			this.removeAllPopup()
		},
		stopMarkerAnimation() {
			clearInterval(this.markerAnimationInterval)
			this.markerList.map(element => {
				element.marker._element.classList.remove('active')
			})
		},
		runMapEvents() {
			this.$root.$on('activateMarker', (index) => {
				this.activateMarker(index)
			})
			this.$root.$on('hideActiveMarkers', () => {
				this.hideActiveMarkers()
			})
			this.$root.$on('createIndicator', (coord) => {
				this.createIndicator(coord)
			})
			this.$root.$on('createMarker', (data) => {
				this.createMarker(data)
			})
			this.$root.$on('createMarkers', (points) => {
				this.createMarkers(points)
			})
			this.$root.$on('removeAllMarkers', () => {
				this.removeAllMarkers()
			})
			this.$root.$on('createPointOfInterest', (place) => {
				this.createPointOfInterest(place)
			})
			this.$root.$on('removeAllPointsOfInterest', () => {
				this.removeAllPointsOfInterest()
			})
			this.$root.$on('runMarkerAnimation', () => {
				this.runMarkerAnimation()
			})
			this.$root.$on('stopMarkerAnimation', () => {
				this.stopMarkerAnimation()
			})
			this.$root.$on('highlightRegions', (regions) => {
				this.highlightRegions(regions)
			})
		}
	}
}
</script>

<style lang="scss">
$previe-circle-size: 200px;

#map {
	position: absolute;
	top: 0;
	bottom: 0;
	width: 100%;
	z-index: 0;
}
#preview-map {
	width: 320px;
	height: 245px;
	float: right;
	border: 1px solid #2c6b62;
	top: 63%;
	position: absolute;
	right: 1%;

	.mapboxgl-ctrl-logo {
		display: none;
	}
	.circle-preview {
		background: #4ba98b63;
		width: $previe-circle-size;
		height: $previe-circle-size;
		border-radius: 100%;
		position: absolute;
		top: 50%;
		margin-left: -($previe-circle-size/2);
		left: 50%;
		margin-top: -($previe-circle-size/2);
		z-index: 1;
	}
}

.mapboxgl-ctrl-group {
	margin: 63px 0 0 !important;
	border-radius: 0 !important;
}
.mapboxgl-ctrl-zoom-in,
.mapboxgl-ctrl-zoom-out {
	width: 55px !important;
	height: 55px !important;
	background: #3a9fd0 !important;
	color: #fff !important;

	&::after {
		content: '+';
		font-size: 40px;
		position: relative;
		top: -5px;
	}
}

.mapboxgl-ctrl-zoom-out {
	&::after {
		content: '-';
		position: relative;
		top: -5px;
	}
}
.mapboxgl-ctrl-compass {
	display: none !important;
}

.marker {
	width: 35px;
	height: 35px;
	border-radius: 50%;
	cursor: pointer;
	position: absolute;
	font-size: 28px;
	text-align: center;
	font-weight: 300;
	border: 0;
	transition: 1s background linear;
	background-color: #8080801c;
	border: 1px solid #3179984f;

	&:after {
		content: "\002B";
		color: #56626e;
		line-height: 1;
	}

	&:hover {
		background-color: #ababab1a;
		border: 1px solid #317998;

		&:after {
			color: #fff;
		}
	}
}
.marker.popupActive {
	background: url('../../../assets/images/markers/active_marker.svg');
	border: none;

	&:after {
		content: "\25CF";
		font-size: 14px;
		color: #fff !important;
		line-height: 32px;
	}
}
.marker.active {
	background-color: #ababab1a;
	border: 1px solid #317998;

	&:after {
		color: #fff;
	}
}
.indicator {
	width: 40px;
	height: 40px;
	background-size: cover;
	animation: indicatorAnim 2s linear infinite;
	display: none;
}

.point-of-interest-marker {
	background-image: url('../../../assets/images/pointOfInterest/default.svg');
	background-size: cover;
	width: 40px;
	height: 40px;
	margin-top: -20px;
	display: none;

	&:hover {
		cursor: pointer;
	}
}

.point-of-interest-marker.point-type-school {
	background-image: url('../../../assets/images/pointOfInterest/school.svg');
}
.point-of-interest-marker.point-type-hospital {
	background-image: url('../../../assets/images/pointOfInterest/hospital.svg');
}
.point-of-interest-marker.point-type-government {
	background-image: url('../../../assets/images/pointOfInterest/government.svg');
}
.point-of-interest-marker.point-type-attraction {
	background-image: url('../../../assets/images/pointOfInterest/attraction.svg');
}
.point-of-interest-marker.point-type-rail_station {
	background-image: url('../../../assets/images/pointOfInterest/rail_station.svg');
}
.point-of-interest-marker.point-type-bus_station {
	background-image: url('../../../assets/images/pointOfInterest/bus_station.svg');
}
.point-of-interest-marker.point-type-port {
	background-image: url('../../../assets/images/pointOfInterest/port.svg');
}
.point-of-interest-marker.point-type-airport {
	background-image: url('../../../assets/images/pointOfInterest/airport.svg');
}

.point-popup {
	opacity: 0;
}
.point-popup.active {
	opacity: 1;
}

.mapboxgl-popup-content {
	margin-left: 50px;
	border-radius: 5px !important;
	font-weight: 400;
	color: #2a2b2b;
	padding: 10px 15px !important;
	line-height: 13px;
	font-family: raleway;
	
	h4 {
		margin: 0;
		font-size: 12px;
		font-weight: 500;
	}
	span {
		font-size: 10px;
	}
	ul {
		margin: 0;
		padding-left: 17px;
		display: inline-block;

		a {
			font-size: 10px;
			margin-left: -4px;
			color: #44a7d4;
			cursor: pointer;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}
.popup-oil {
	top: 25px !important;
	left: 70px !important;
	max-width: 250px !important;
	
	.mapboxgl-popup-tip {
		display: none;
	}
	.mapboxgl-popup-content {
		background: none;
		box-shadow: none;
		padding: 0 !important;
		margin: 0;
	}
}

@keyframes indicatorAnim {
	0% {
		background-image: url('../../../assets/images/markers/indicator_3.svg');
	}
	25% {
		background-image: url('../../../assets/images/markers/indicator_2.svg');
	}
	50% {
		background-image: url('../../../assets/images/markers/indicator_1.svg');
	}
	75% {
		background-image: url('../../../assets/images/markers/indicator_2.svg');
	}
	100% {
		background-image: url('../../../assets/images/markers/indicator_3.svg');
	}
}
</style>